<template>
  <div
    class="leading-4.5 flex flex-wrap gap-y-2 pb-2 font-inter text-xs font-medium text-gray-100"
  >
    <div v-for="(link, index) in links" :key="index" class="flex items-center">
      <button
        v-if="index === 0"
        :class="[
          actualPath === link.path
            ? 'text-gray-50'
            : 'cursor-pointer hover:text-gray-100',
        ]"
        class="leading-4.5 rounded-md bg-gray-600 px-[10px] py-[7px] font-inter text-xs font-medium text-gray-100"
        :disabled="links.length < 2"
        @click="$emit('chooseFolder', link.path, index)"
      >
        {{ link.name }}
      </button>
      <TDropdown v-else ref="dropdownFolders">
        <template #selected-content>
          <p style="min-width: 70px; text-align: left; padding-left: 0px">
            {{ link.name }}
          </p>
        </template>

        <template #content>
          <ul>
            <VueCustomScrollbar
              style="position: relative; margin: auto"
              :style="{ height: calculatedHeightFolders(index - 1) + 'px' }"
              :settings="{ wheelPropagation: false }"
            >
              <li
                v-for="(folder, k) in folders[index - 1]"
                :key="k"
                style="
                  padding: 4px 0;
                  display: flex;
                  justify-content: flex-start;
                "
                @click="
                  $emit('chooseFolder', folder.path + folder.name + '/', index);
                  closeDrop(index - 1);
                "
              >
                <p style="width: 120px; padding-left: 12px">
                  {{ folder.name }}
                </p>
              </li>
            </VueCustomScrollbar>
          </ul>
        </template>
      </TDropdown>
      <span
        v-if="
          index !== links.length - 1 ||
          (folders[index] && folders[index].length > 0)
        "
        class="inline-grid h-[20px] w-[20px] items-center justify-center"
      >
        <font-awesome-icon :icon="['fas', 'angle-right']" />
      </span>
    </div>
    <TDropdown
      v-if="folders[links.length - 1] && folders[links.length - 1].length > 0"
      ref="dropdownFoldersLast"
    >
      <template #selected-content>
        <p
          class="pl-0 text-left"
          :class="{
            'w-[70px]': dropdownFoldersLast?.opened,
          }"
        >
          ...
        </p>
      </template>

      <template #content>
        <ul>
          <VueCustomScrollbar
            style="position: relative; margin: auto"
            :style="{
              height: calculatedHeightFolders(links.length - 1) + 'px',
            }"
            :settings="{ wheelPropagation: false }"
          >
            <li
              v-for="(folder, k) in folders[links.length - 1]"
              :key="k"
              style="padding: 4px 0; display: flex; justify-content: flex-start"
              @click="$emit('chooseFolder', folder.path + folder.name + '/')"
            >
              <p style="width: 120px; padding-left: 12px">
                {{ folder.name }}
              </p>
            </li>
          </VueCustomScrollbar>
        </ul>
      </template>
    </TDropdown>
  </div>
</template>

<script setup lang="ts">
import { IImage } from "../../../../schemas/imageSchema";
import { TDropdown } from "@topol/ui";
import { PerfectScrollbar as VueCustomScrollbar } from "vue3-perfect-scrollbar";
import { ref } from "vue";

interface Link {
  name: string;
  path: string;
}

const props = defineProps<{
  links: Array<Link>;
  folders: Array<IImage[]>;
  actualPath: string;
}>();

defineEmits(["chooseFolder"]);

const dropdownFolders = ref();
const dropdownFoldersLast = ref();

function calculatedHeightFolders(i: number) {
  const height = props.folders[i].length * 32;
  if (height > 125) {
    return 125;
  }
  return height;
}

function closeDrop(index: number) {
  dropdownFolders.value[index].opened = false;
}
</script>
